(function () {
  'use strict';

  var drawer, panel, body, footer, countEl, subtotalEl;
  var lastFocus = null;
  // Tracks whether free shipping was already unlocked on the previous render,
  // so the confetti burst only fires on the locked -> unlocked transition
  // (not every time the drawer re-renders with the threshold already met).
  var shippingUnlocked = null;
  var moneyFormat = (window.Shopify && Shopify.money_format) || '${{amount}}';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function init() {
    drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    panel = $('[data-cart-drawer-panel]', drawer);
    body = $('[data-cart-drawer-body]', drawer);
    footer = $('[data-cart-drawer-footer]', drawer);
    // Prefer the shop's real format over Shopify.money_format - see the note on
    // data-money-format in sections/cart-drawer.liquid.
    var declaredFormat = drawer.getAttribute('data-money-format');
    if (declaredFormat) moneyFormat = declaredFormat;
    countEl = $('[data-cart-drawer-count]', drawer);
    subtotalEl = $('[data-cart-drawer-subtotal]', drawer);

    // Close handlers
    $$('[data-cart-drawer-close]', drawer).forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });

    // Wire header cart icons to open the drawer instead of navigating
    $$('a[href="/cart"], a[href$="/cart"], .custom-header__cart, .site-header-cart--button').forEach(function (link) {
      // Only intercept top-level cart-icon links in the header, not in-page "View cart" links
      if (link.closest('[data-cart-drawer]')) return; // skip the drawer's own "View cart" link
      link.addEventListener('click', function (e) {
        // Allow modifier-click (open in new tab) to still go to /cart
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        open();
      });
    });

    // Keyboard
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Re-render after add-to-cart elsewhere.
    // Always refetch with section rendering so Judge.me badges (and any other
    // server-rendered item bits) come back populated.
    document.addEventListener('cart:updated', function (e) {
      var cart = e && e.detail;
      // Build the shipping bar + recs immediately from cart data, so they show
      // without waiting for any fetch.
      renderShippingBarFromCart(cart);
      renderRecsFromCart(cart);
      // Already brought up to date in place by changeLine - re-rendering here
      // would refetch markup we deliberately did not ask for.
      if (patchedCart && cart === patchedCart) return;
      if (cart && cart.sections && cart.sections['cart-drawer']) {
        render(cart);
      } else {
        fetchAndRender();
      }
      // No unconditional /cart fetch here any more. render() upgrades the items
      // list from the section the cart API returned, and only falls back to the
      // page when that is missing - so this was a second, 1.4MB request for
      // markup already in hand. The note it used to carry, that this store does
      // not get ?sections= data back, is not true: /cart/change.js?sections=
      // cart-drawer returns the section, Judge.me badge markup included.
    });

    // Delegated handlers inside the drawer
    drawer.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-rec-add]');
      if (addBtn) {
        e.preventDefault();
        addRecToCart(addBtn);
        return;
      }

      var dismissBtn = e.target.closest('[data-rec-dismiss]');
      if (dismissBtn) {
        e.preventDefault();
        var card = dismissBtn.closest('[data-rec-card]');
        if (card) card.remove();
        return;
      }

      var item = e.target.closest('[data-cart-drawer-item]');
      if (!item) return;
      var line = parseInt(item.getAttribute('data-line'), 10);

      if (e.target.closest('[data-cart-drawer-qty-increase]')) {
        e.preventDefault();
        queueQty(item, line, getQty(item) + 1, e.target.closest('[data-cart-drawer-qty-increase]'));
      } else if (e.target.closest('[data-cart-drawer-qty-decrease]')) {
        e.preventDefault();
        var next = getQty(item) - 1;
        queueQty(item, line, next < 0 ? 0 : next, e.target.closest('[data-cart-drawer-qty-decrease]'));
      } else if (e.target.closest('[data-cart-drawer-remove]')) {
        e.preventDefault();
        var removeBtn = e.target.closest('[data-cart-drawer-remove]');
        // Already removing — ignore repeat clicks so we don't fire duplicate
        // change requests while the first is in flight.
        if (removeBtn.classList.contains('is-loading')) return;
        // Immediate feedback: swap the trash icon for a spinner and dim the
        // row so the customer can see the item is on its way out. The state is
        // cleared automatically when changeLine() re-renders the drawer body
        // (or resyncs on failure).
        removeBtn.classList.add('is-loading');
        removeBtn.disabled = true;
        item.classList.add('is-removing');
        // Drop a queued +/- for this row, or it would fire after the removal and
        // put the line back.
        cancelQty(line);
        changeLine(line, 0);
      }
    });

    drawer.addEventListener('change', function (e) {
      if (e.target.matches('[data-cart-drawer-qty-input]')) {
        var item = e.target.closest('[data-cart-drawer-item]');
        var line = parseInt(item.getAttribute('data-line'), 10);
        var val = parseInt(e.target.value, 10);
        if (isNaN(val) || val < 0) val = 0;
        // A typed value is the customer being explicit; it supersedes anything
        // the +/- buttons had queued for this row.
        cancelQty(line);
        changeLine(line, val);
        return;
      }

      if (e.target.matches('[data-rec-variant]')) {
        var card = e.target.closest('[data-rec-card]');
        if (card) syncCardToSelectedVariant(card);
      }
    });
  }

  // The +/- buttons used to fire a cart request per click and show nothing until
  // it came back, so on a ~1s round trip the number sat still and the drawer felt
  // broken - and holding + fired a request per press, each queued behind the last.
  //
  // The displayed quantity now updates on the click, and the request is held
  // briefly so a burst of presses collapses into one call carrying the final
  // quantity. getQty reads the input, so each press builds on the optimistic
  // value rather than the last server-confirmed one.
  var qtyTimer = null;
  var qtyPending = null; // { line, qty }

  function flushQty() {
    if (qtyTimer) { clearTimeout(qtyTimer); qtyTimer = null; }
    if (!qtyPending) return;
    var p = qtyPending;
    qtyPending = null;
    changeLine(p.line, p.qty);
  }

  // Move the money with the quantity. Without this the number changed on the click
  // and the line price and subtotal only caught up when the server answered ~700ms
  // later, so the row visibly updated in two stages - which is the part that reads
  // as unsmooth, separately from how long the request takes.
  //
  // final_price and original_price are per unit, so the line total is just unit x
  // quantity. That is exact for ordinary pricing and can be briefly wrong where a
  // discount is tiered by quantity; patchLines overwrites it with the server's
  // figures either way, so the worst case is a corrected number, not a stuck one.
  function priceOptimistically(item, qty) {
    if (!lastCart || !lastCart.items) return;
    var key = item.getAttribute('data-key');
    var it = null;
    for (var i = 0; i < lastCart.items.length; i++) {
      if (lastCart.items[i].key === key) { it = lastCart.items[i]; break; }
    }
    if (!it) return;

    var price = $('[data-cart-drawer-item-price]', item);
    if (price) {
      price.innerHTML = linePriceHtml({
        final_line_price: it.final_price * qty,
        original_line_price: it.original_price * qty,
        line_level_discount_allocations: it.line_level_discount_allocations
      });
    }
    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(lastCart.total_price + (qty - it.quantity) * it.final_price);
    }
  }

  function clearQtySpinners() {
    $$('.cart-drawer__qty-btn.is-loading').forEach(function (b) {
      b.classList.remove('is-loading');
    });
  }

  function cancelQty(line) {
    if (qtyPending && qtyPending.line === line) {
      qtyPending = null;
      if (qtyTimer) { clearTimeout(qtyTimer); qtyTimer = null; }
    }
  }

  function queueQty(item, line, qty, btn) {
    // A different row while one is still waiting: send that one first, so two
    // concurrent change requests cannot race and have the loser's stale cart win.
    if (qtyPending && qtyPending.line !== line) flushQty();

    var input = $('[data-cart-drawer-qty-input]', item);
    if (input) input.value = qty;
    if (btn) btn.classList.add('is-loading');
    priceOptimistically(item, qty);

    qtyPending = { line: line, qty: qty };
    if (qtyTimer) clearTimeout(qtyTimer);
    qtyTimer = setTimeout(flushQty, 300);
  }

  function getQty(item) {
    var input = $('[data-cart-drawer-qty-input]', item);
    var v = parseInt(input && input.value, 10);
    return isNaN(v) ? 0 : v;
  }

  function open() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-drawer-open');
    document.body.classList.add('cart-drawer-open');
    // Refresh contents from /cart.js so it's always current
    fetchAndRender();
    // Focus the close button for a11y
    var closeBtn = $('.cart-drawer__close', drawer);
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-drawer-open');
    document.body.classList.remove('cart-drawer-open');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function fetchAndRender() {
    return fetch('/cart.js?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  // Fetch the rendered /cart page and replace the drawer body with the
  // server-rendered markup. We use this because Shopify's sections API
  // does not return our cart-drawer section on /cart.js, so the only way
  // to get the metafield-rendered Judge.me badges (with real review
  // counts), accurate variant titles, etc. is to read them out of the
  // cart page HTML. Runs async; the JS-rendered items list is shown
  // immediately and gets upgraded once this resolves.
  // Swap the drawer body for server-rendered markup we already hold. Split out of
  // fetchCartPageAndUpgradeBody so the same logic can be fed either the section
  // HTML returned by the cart API or, as a fallback, the /cart page.
  // Rx ship-to-business box above Checkout (snippets/rx-ship-notice.liquid):
  // show it when any rendered line carries data-rx-item, hide it otherwise.
  // The server renders it only when the cart holds an Rx line, so when an Rx
  // item arrives via ajax the box is created here; its CSS is always emitted.
  var RX_SHIP_BOX = '<div class="rx-ship rx-ship--box" data-rx-ship-box>' +
    '<svg class="rx-ship__ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-5h6v5M9 11h.01M15 11h.01M12 11h.01"/></svg>' +
    '<span><b>Your cart has Rx items.</b> They ship to a business address only. Not to a home.</span></div>';
  function syncRxShipBox() {
    if (!footer || !body) return;
    var hasRx = !!body.querySelector('[data-rx-item]');
    var box = $('[data-rx-ship-box]', footer);
    if (hasRx && !box) {
      var actions = $('.cart-drawer__actions', footer);
      if (actions) actions.insertAdjacentHTML('beforebegin', RX_SHIP_BOX);
    } else if (box) {
      box.hidden = !hasRx;
    }
  }

  function upgradeBodyFrom(freshDrawer) {
    if (!freshDrawer || !body) return false;
    if (body.querySelector('[data-cart-drawer-empty]')) return false;
    var newBody = freshDrawer.querySelector('[data-cart-drawer-body]');
    if (!newBody || newBody.querySelector('[data-cart-drawer-empty]')) return false;
    body.innerHTML = newBody.innerHTML;
    syncRxShipBox();
    syncSimilar(freshDrawer);
    if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      try { window.jdgm.customizeBadges(); } catch (err) {}
    }
    return true;
  }

  // The cart API returns the rendered section alongside the JSON whenever the
  // request carries ?sections=cart-drawer, which every call here already does.
  // Measured on production: that section is 34KB, against 1436KB for the /cart
  // page it used to fetch to get the same markup - and it costs nothing extra,
  // because it arrives in a response we are already waiting for. Removing that
  // second request took a quantity change from ~1948ms to ~1028ms.
  function upgradeBodyFromSections(cart) {
    var html = cart && cart.sections && cart.sections['cart-drawer'];
    if (!html) return false;
    try {
      return upgradeBodyFrom(new DOMParser().parseFromString(html, 'text/html'));
    } catch (e) { return false; }
  }

  function fetchCartPageAndUpgradeBody() {
    // Nothing to upgrade when the cart is empty. The empty state holds the
    // search field; replacing body.innerHTML here (async, network-timed) would
    // wipe what the user is typing and make the search intermittently fail.
    if (!body || body.querySelector('[data-cart-drawer-empty]')) return Promise.resolve();
    return fetch('/cart', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // If the cart became empty in the meantime, upgradeBodyFrom declines —
        // render() already handles empties and owns the search field.
        upgradeBodyFrom(doc.getElementById('cart-drawer'));
      })
      .catch(function () {});
  }

  function changeLine(line, qty) {
    if (!line) return;
    // Removing a line changes the list, so that still needs the re-rendered
    // section. A quantity change only moves numbers, and paying ~500ms for markup
    // we would throw away is the bulk of why changing quantity felt slow.
    var needsSection = (qty === 0);
    return fetch(needsSection ? '/cart/change.js?sections=cart-drawer' : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Patch in place when we can; the listener below then skips its render.
        // Dispatch either way so the other cart listeners stay in sync.
        if (!needsSection && patchLines(cart)) patchedCart = cart;
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        patchedCart = null;
      })
      // On failure, refetch the real cart state and re-render so any in-flight
      // loading/removing state (e.g. the remove spinner) is cleared instead of
      // being left stuck on a row that never went away.
      .catch(function () { clearQtySpinners(); fetchAndRender(); });
  }

  function applySectionHtml(cart) {
    var sectionHtml = cart && cart.sections && cart.sections['cart-drawer'];
    if (!sectionHtml || !body) return false;
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var newBody = doc.querySelector('[data-cart-drawer-body]');
    if (!newBody) return false;
    // Don't clobber a live empty state (which holds the search field + populated
    // recommendations) with another empty render. Shopify returns section HTML
    // only intermittently, so this path would otherwise wipe what the user is
    // typing and make the search fail some of the time but not others.
    if (body.querySelector('[data-cart-drawer-empty]') && newBody.querySelector('[data-cart-drawer-empty]')) {
      syncSimilar(doc);
      return true;
    }
    body.innerHTML = newBody.innerHTML;
    syncSimilar(doc);
    if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      try { window.jdgm.customizeBadges(); } catch (err) {}
    }
    return true;
  }

  // Build/update the free shipping progress bar from the cart object alone.
  // Used because this store's Shopify config does not return ?sections= data
  // on /cart.js, so we cannot rely on server-rendered HTML to appear on
  // ajax cart updates. Recommendations still come from the initial
  // server-rendered drawer (or a later section render if it is enabled).
  function renderShippingBarFromCart(cart) {
    if (!drawer || !cart) return;
    var enabled = drawer.getAttribute('data-shipping-enabled') === 'true';
    var threshold = parseInt(drawer.getAttribute('data-shipping-threshold'), 10);
    var existing = $('[data-cart-drawer-shipping]', drawer);

    if (!enabled || !threshold || threshold <= 0 || cart.item_count <= 0) {
      if (existing) existing.remove();
      shippingUnlocked = null;
      return;
    }

    var thresholdCents = threshold * 100;
    var cartTotalCents = cart.total_price || 0;
    var remainingCents = thresholdCents - cartTotalCents;
    var pct = thresholdCents > 0 ? Math.min(100, (cartTotalCents * 100) / thresholdCents) : 0;

    var extraPct = parseInt(drawer.getAttribute('data-shipping-extra-percent'), 10) || 0;
    var targetLabel = drawer.getAttribute('data-shipping-target-label') ;
    var goalFlagImg = drawer.getAttribute('data-shipping-flag-img') || '';
    var THUMB_SVG = '<svg viewBox="0 0 24 30"><defs><filter id="cartFlagWave" x="-70%" y="-70%" width="240%" height="240%"><feTurbulence type="fractalNoise" baseFrequency="0.014 0.05" numOctaves="2" seed="3" result="noise"><animate attributeName="baseFrequency" dur="2s" values="0.012 0.04;0.024 0.075;0.012 0.04" repeatCount="indefinite"/></feTurbulence><feDisplacementMap in="SourceGraphic" in2="noise" xChannelSelector="R" yChannelSelector="G"><animate attributeName="scale" values="3.5;6.5;3.5" dur="2s" repeatCount="indefinite"/></feDisplacementMap></filter></defs><rect x="2" y="2" width="2" height="26" rx="1" fill="#8a5a2b"/><g class="cart-flag" filter="url(#cartFlagWave)"><rect x="4" y="3" width="17" height="2" fill="#b22234"/><rect x="4" y="5" width="17" height="2" fill="#fff"/><rect x="4" y="7" width="17" height="2" fill="#b22234"/><rect x="4" y="9" width="17" height="2" fill="#fff"/><rect x="4" y="11" width="17" height="2" fill="#b22234"/><rect x="4" y="13" width="17" height="2" fill="#fff"/><rect x="4" y="15" width="17" height="2" fill="#b22234"/><rect x="4" y="3" width="7.5" height="6" fill="#3c3b6e"/><g fill="#fff"><circle cx="5.6" cy="4.3" r="0.42"/><circle cx="7.7" cy="4.3" r="0.42"/><circle cx="9.8" cy="4.3" r="0.42"/><circle cx="6.65" cy="5.7" r="0.42"/><circle cx="8.75" cy="5.7" r="0.42"/><circle cx="5.6" cy="7.1" r="0.42"/><circle cx="7.7" cy="7.1" r="0.42"/><circle cx="9.8" cy="7.1" r="0.42"/></g></g></svg>';
    var STAR_SVG = '<span></span>';

    var GOAL_HTML = goalFlagImg
      ? '<img src="' + goalFlagImg + '" alt="" loading="lazy">'
      : STAR_SVG;
    var goalClass = 'cart-drawer__shipping-goal' + (goalFlagImg ? ' cart-drawer__shipping-goal--image' : '');

    var unlocked = remainingCents <= 0;

    // Celebrate the moment the customer crosses the free-shipping threshold.
    // shippingUnlocked === null means this is the first render (e.g. drawer
    // just opened) — establish the baseline silently so we don't blast
    // confetti for a cart that was already over the threshold.
    if (shippingUnlocked === false && unlocked) {
      fireConfetti();
    }
    shippingUnlocked = unlocked;

    // When a discount promo is active (date-windowed server-side), the bar
    // message promotes both the discount and free shipping in one line.
    var discountActive = drawer.getAttribute('data-discount-enabled') === 'true';
    var discountPercent = parseInt(drawer.getAttribute('data-discount-percent'), 10) || 0;
    var discountCode = drawer.getAttribute('data-discount-code') || '';

    var shippingText;
    if (remainingCents > 0) {
      if (discountActive) {
        shippingText = 'Spend <strong class="money">' + formatMoney(remainingCents) +
          '</strong> more to unlock <strong>' + discountPercent + '% off</strong> &amp; <strong>Free shipping</strong>';
      } else {
        shippingText = 'You\'re only <strong class="money">' + formatMoney(remainingCents) +
          '</strong> away from free shipping';
      }
    } else {
      if (discountActive) {
        shippingText = '🎉 You\'ve unlocked <strong>' + discountPercent + '% off</strong> &amp; <strong>Free shipping</strong>!' +
          (discountCode ? ' Use code <span class="cart-drawer__shipping-code">' + escapeHtml(discountCode) + '</span> at checkout' : '');
      } else {
        shippingText = 'You\'ve unlocked free shipping';
      }
    }

    var barWidth = remainingCents > 0 ? pct : 100;
    var shippingHtml =
      '<div class="cart-drawer__shipping-text">' + shippingText + '</div>' +
      '<div class="cart-drawer__shipping-track">' +
        '<span class="cart-drawer__shipping-fill" style="width:' + barWidth + '%"></span>' +
        '<span class="cart-drawer__shipping-thumb" style="left:' + barWidth + '%" aria-hidden="true">' + THUMB_SVG + '</span>' +
        '<span class="' + goalClass + '" aria-hidden="true">' + GOAL_HTML + '</span>' +
      '</div>' +
      '<div class="cart-drawer__shipping-scale">' +
        // '<span class="cart-drawer__shipping-current money">' + formatMoney(cartTotalCents) + '</span>' +
        '<span class="cart-drawer__shipping-target">' + targetLabel + '</span>' +
      '</div>';

    var el = existing;
    if (!el) {
      var bodyEl = $('[data-cart-drawer-body]', drawer);
      if (!bodyEl) return;
      el = document.createElement('div');
      el.setAttribute('data-cart-drawer-shipping', '');
      bodyEl.parentNode.insertBefore(el, bodyEl);
    }
    el.className = 'cart-drawer__shipping cart-drawer__shipping--patriotic';
    el.innerHTML = shippingHtml;
  }

  // Toggle the subtotal promo badge between its "locked" and "unlocked" pill
  // text once the cart total reaches the free-shipping threshold. The footer
  // markup is not rebuilt on ajax updates, so this updates it in place.
  function updatePromoBadge(cart) {
    if (!drawer || !cart) return;
    var badge = $('[data-cart-promo-badge]', drawer);
    if (!badge) return;
    var threshold = parseInt(badge.getAttribute('data-threshold'), 10) || 0;
    var unlocked = threshold > 0 && (cart.total_price || 0) >= threshold;
    badge.classList.toggle('is-unlocked', unlocked);

    var textEl = $('.cart-drawer__promo-badge-text', badge);
    if (textEl) {
      var textLocked = badge.getAttribute('data-text-locked') || '';
      var textUnlocked = badge.getAttribute('data-text-unlocked') || '';
      textEl.textContent = unlocked && textUnlocked ? textUnlocked : textLocked;
    }

    var pill = $('[data-cart-promo-pill]', badge);
    if (!pill) return;
    var locked = badge.getAttribute('data-pill-locked') || '';
    var extraPct = parseInt(badge.getAttribute('data-extra-percent'), 10) || 0;
    var txt;
    if (unlocked) {
      // After the threshold, show the actual discount amount (extra % off subtotal).
      var discountCents = Math.round(((cart.total_price || 0) * extraPct) / 100);
      txt = '−' + formatMoney(discountCents);
    } else {
      txt = locked;
    }
    pill.textContent = txt;
    pill.style.display = txt ? '' : 'none';
  }

  // Build/update the "You may also like" carousel from Shopify's
  // /recommendations/products.json API. Same fallback path as the
  // shipping bar since server-rendered sections are unavailable here.
  var lastRecsKey = null;
  function renderRecsFromCart(cart) {
    if (!drawer || !cart) return;
    var enabled = drawer.getAttribute('data-recs-enabled') === 'true';

    if (!enabled || !cart.items || cart.items.length === 0) {
      removeSimilar();
      lastRecsKey = null;
      return;
    }

    var firstProductId = cart.items[0].product_id;
    if (!firstProductId) return;

    var inCart = cart.items.map(function (i) { return i.product_id; }).sort().join(',');
    var key = firstProductId + '|' + inCart;
    if (key === lastRecsKey) return;
    lastRecsKey = key;

    var inCartIds = {};
    cart.items.forEach(function (i) { inCartIds[i.product_id] = true; });
    var customerLicensed = drawer.getAttribute('data-customer-licensed') === 'true';

    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(firstProductId) + '&limit=12&intent=related', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.products) || [];
        var filtered = products.filter(function (p) {
          if (inCartIds[p.id]) return false;
          if (p.available === false) return false;
          if (!customerLicensed && isRestrictedProduct(p)) return false;
          return true;
        });
        if (filtered.length === 0) {
          removeSimilar();
          return;
        }
        // renderSimilarProducts(filtered);
      })
      .catch(function () {});
  }

  function isRestrictedProduct(product) {
    var tags = (product.tags || []).map(function (t) { return String(t).toLowerCase(); });
    var type = (product.type || '').toLowerCase();
    if (type === 'prescription') return true;
    var restricted = ['doctor-only', 'rx', 'prescription', 'rx-only', 'medical-license'];
    for (var i = 0; i < restricted.length; i++) {
      if (tags.indexOf(restricted[i]) !== -1) return true;
    }
    return false;
  }

  function renderSimilarProducts(products) {
    var cardsHtml = products.map(buildSimilarCard).join('');
    var title = drawer.getAttribute('data-recs-title') || 'Similar Products';

    // Desktop sidebar lives inside the panel, before .cart-drawer__main
    var panelEl = $('[data-cart-drawer-panel]', drawer);
    var sidebar = $('[data-cart-drawer-similar]', drawer);
    if (!sidebar && panelEl) {
      sidebar = document.createElement('div');
      sidebar.className = 'cart-drawer__similar';
      sidebar.setAttribute('data-cart-drawer-similar', '');
      panelEl.insertBefore(sidebar, panelEl.firstChild);
    }
    if (sidebar) {
      sidebar.innerHTML =
        '<h3 class="cart-drawer__similar-title">' + escapeHtml(title) + '</h3>' +
        '<div class="cart-drawer__similar-track" data-cart-drawer-similar-track>' + cardsHtml + '</div>';
    }

    // Mobile block lives inside the body after the cart items
    var bodyEl = $('[data-cart-drawer-body]', drawer);
    var mobile = $('[data-cart-drawer-similar-mobile]', drawer);
    if (!mobile && bodyEl) {
      mobile = document.createElement('div');
      mobile.className = 'cart-drawer__similar-mobile';
      mobile.setAttribute('data-cart-drawer-similar-mobile', '');
      bodyEl.appendChild(mobile);
    }
    if (mobile) {
      mobile.innerHTML =
        '<h3 class="cart-drawer__similar-title">' + escapeHtml(title) + '</h3>' +
        '<div class="cart-drawer__similar-mobile-track" data-cart-drawer-similar-mobile-track>' + cardsHtml + '</div>';
    }
  }

  // Only the theme's own mobile block is removed. The sidebar stays: it is the
  // upsell app's injection target and CSS hides it while it is empty.
  function removeSimilar() {
    var mobile = $('[data-cart-drawer-similar-mobile]', drawer);
    if (mobile) mobile.remove();
  }

  function buildSimilarCard(product) {
    var imageSrc = product.featured_image || (product.images && product.images[0]) || '';
    if (imageSrc && typeof imageSrc === 'object' && imageSrc.src) imageSrc = imageSrc.src;
    var imgUrl = imageSrc ? imageUrl(imageSrc, 160) : '';
    var variants = (product.variants && product.variants.length) ? product.variants : [];
    var defaultVariant = null;
    for (var di = 0; di < variants.length; di++) {
      if (variants[di].available !== false) { defaultVariant = variants[di]; break; }
    }
    if (!defaultVariant && variants.length) defaultVariant = variants[0];
    var variantId = defaultVariant ? defaultVariant.id : '';
    var defaultPrice = defaultVariant && defaultVariant.price != null ? defaultVariant.price : product.price;
    var defaultCompare = defaultVariant && defaultVariant.compare_at_price != null ? defaultVariant.compare_at_price : product.compare_at_price;
    var url = escapeAttr(product.url || '#');
    var hasCompare = defaultCompare && defaultCompare > defaultPrice;
    var dismissSvg = '<svg width="10" height="10" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

    var hasRealVariants = variants.length > 1 || (variants[0] && variants[0].title !== 'Default Title');
    var optionsHtml = !hasRealVariants ? '' : variants.map(function (v) {
      var disabled = (v.available === false) ? ' disabled' : '';
      var selected = (defaultVariant && v.id === defaultVariant.id) ? ' selected' : '';
      var label = (v.title || '') + (v.available === false ? ' — Sold out' : '');
      return '<option value="' + escapeAttr(v.id) + '"' +
        ' data-price="' + escapeAttr(v.price != null ? v.price : '') + '"' +
        ' data-compare-price="' + escapeAttr(v.compare_at_price != null ? v.compare_at_price : 0) + '"' +
        selected + disabled + '>' + escapeHtml(label) + '</option>';
    }).join('');

    return '<div class="cart-drawer__similar-card" data-rec-card data-product-id="' + escapeAttr(product.id) + '">' +
      '<button type="button" class="cart-drawer__similar-card-dismiss" data-rec-dismiss aria-label="Dismiss">' + dismissSvg + '</button>' +
      '<a class="cart-drawer__similar-card-img" href="' + url + '">' +
        (imgUrl ? '<img src="' + escapeAttr(imgUrl) + '" alt="' + escapeAttr(product.title || '') + '" loading="lazy" width="80" height="80">' : '') +
      '</a>' +
      '<div class="cart-drawer__similar-card-info">' +
        '<a class="cart-drawer__similar-card-title" href="' + url + '">' + escapeHtml(product.title || '') + '</a>' +
        (hasRealVariants ? '<select class="cart-drawer__similar-card-variant" data-rec-variant aria-label="Choose a variant for ' + escapeAttr(product.title || '') + '">' + optionsHtml + '</select>' : '') +
        '<div class="cart-drawer__similar-card-prices" data-rec-prices>' +
          (hasCompare ? '<span class="cart-drawer__similar-card-compare">' + formatMoney(defaultCompare) + '</span>' : '') +
          '<span class="cart-drawer__similar-card-price">' + formatMoney(defaultPrice) + '</span>' +
        '</div>' +
        '<button type="button" class="cart-drawer__similar-card-add" data-rec-add data-variant-id="' + escapeAttr(variantId) + '">Add to Cart</button>' +
      '</div>' +
    '</div>';
  }

  function syncCardToSelectedVariant(card) {
    var select = card.querySelector('[data-rec-variant]');
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    var addBtn = card.querySelector('[data-rec-add]');
    if (addBtn) addBtn.setAttribute('data-variant-id', opt.value);
    var prices = card.querySelector('[data-rec-prices]');
    if (!prices) return;
    var price = parseFloat(opt.getAttribute('data-price'));
    var compare = parseFloat(opt.getAttribute('data-compare-price'));
    var priceHtml = '';
    if (!isNaN(compare) && compare > price) {
      priceHtml += '<span class="cart-drawer__similar-card-compare">' + formatMoney(compare) + '</span>';
    }
    if (!isNaN(price)) {
      priceHtml += '<span class="cart-drawer__similar-card-price">' + formatMoney(price) + '</span>';
    }
    prices.innerHTML = priceHtml;
  }

  function addRecToCart(btn) {
    var card = btn.closest('[data-rec-card]');
    var select = card && card.querySelector('[data-rec-variant]');
    var variantId = (select && select.value) || btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw res.data;
        return fetch('/cart.js?sections=cart-drawer', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            render(cart);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          });
      })
      .catch(function () { btn.disabled = false; });
  }

  // The sidebar's content belongs to the upsell app, which injects into it by
  // selector. The server-rendered copy is always empty, so never overwrite or
  // remove what is there - only make sure the element exists.
  function syncSimilar(doc) {
    var panelEl = $('[data-cart-drawer-panel]', drawer);
    var currentSidebar = $('[data-cart-drawer-similar]', drawer);
    if (currentSidebar || !panelEl) return;
    var nextSidebar = doc && doc.querySelector('[data-cart-drawer-similar]');
    var el = nextSidebar ? document.importNode(nextSidebar, true) : document.createElement('div');
    el.className = 'cart-drawer__similar';
    el.setAttribute('data-cart-drawer-similar', '');
    el.innerHTML = '';
    panelEl.insertBefore(el, panelEl.firstChild);
  }

  function render(cart) {
    if (!drawer || !cart) return;
    lastCart = cart;
    // Toggle the empty-state header ("Your cart is empty" replaces "Cart (0)").
    drawer.classList.toggle('is-empty', !cart.items || cart.items.length === 0);
    if (countEl) countEl.textContent = '(' + (cart.item_count || 0) + ')';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (footer) {
      if (cart.item_count > 0) footer.removeAttribute('hidden');
      else footer.setAttribute('hidden', '');
    }
    updateHeaderCount(cart.item_count);
    renderShippingBarFromCart(cart);
    updatePromoBadge(cart);
    renderRecsFromCart(cart);

    if (applySectionHtml(cart)) return;

    if (!cart.items || cart.items.length === 0) {
      // Already showing the empty state (e.g. opening the drawer refetches /cart.js
      // and re-renders). Do NOT re-inject it — that would discard the populated
      // "recently viewed" grid and make it flicker show → hide → show, shifting
      // layout. The empty state is static, so there is nothing to update here.
      if (body.querySelector('[data-cart-drawer-empty]')) return;
      var serverEmpty = document.querySelector('[data-cart-drawer-empty-template]');
      if (serverEmpty) {
        body.innerHTML = serverEmpty.innerHTML;
      } else {
        body.innerHTML = '<div class="cart-drawer__empty" data-cart-drawer-empty>' +
          '<p>Your cart is empty.</p>' +
          '<a class="cart-drawer__continue" href="/collections/all">Continue shopping</a>' +
          '</div>';
      }
      return;
    }


    // /cart.js carries no product tags, so remember which line keys the
    // server marked as Rx (data-rx-item) and keep their tag through this
    // rebuild; the section upgrade below restores it from Liquid anyway.
    var rxKeys = {};
    $$('[data-rx-item]', body).forEach(function (li) { rxKeys[li.getAttribute('data-key')] = true; });
    var RX_SHIP_TAG = '<span class="rx-ship rx-ship--tag" data-rx-ship-tag>' +
      '<svg class="rx-ship__ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-5h6v5M9 11h.01M15 11h.01M12 11h.01"/></svg>' +
      'Rx &middot; ships to business address only</span>';

    var html = '<ul class="cart-drawer__items" data-cart-drawer-items>';
    cart.items.forEach(function (item, i) {
      var isRx = !!rxKeys[item.key];
      var image = item.image ? imageUrl(item.image, 120) : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>' : '';
      if (isRx) variant += RX_SHIP_TAG;
      var reviews = item.product_id
        ? '<div class="cart-drawer__item-reviews"><div class="jdgm-widget jdgm-preview-badge" data-id="' + escapeAttr(item.product_id) + '"></div></div>'
        : '';
      html += '<li class="cart-drawer__item" data-cart-drawer-item data-line="' + (i + 1) + '" data-key="' + escapeAttr(item.key) + '"' + (isRx ? ' data-rx-item' : '') + '>' +
        '<a class="cart-drawer__item-image" href="' + escapeAttr(item.url) + '">' +
          (image ? '<img src="' + escapeAttr(image) + '" alt="' + escapeAttr(item.product_title || item.title || '') + '" loading="lazy" width="60" height="60">' : '') +
        '</a>' +
        '<div class="cart-drawer__item-info">' +
          '<div class="cart-drawer__item-top">' +
            '<a class="cart-drawer__item-title" href="' + escapeAttr(item.url) + '">' + escapeHtml(item.product_title || item.title || '') + '</a>' +
            '<span class="cart-drawer__item-price" data-cart-drawer-item-price>' + linePriceHtml(item) + '</span>' +
          '</div>' +
          variant +
          reviews +
          '<div class="cart-drawer__item-actions">' +
            '<div class="cart-drawer__qty" data-cart-drawer-qty>' +
              '<button type="button" class="cart-drawer__qty-btn" data-cart-drawer-qty-decrease aria-label="Decrease quantity">&minus;</button>' +
              '<input type="number" class="cart-drawer__qty-input" data-cart-drawer-qty-input value="' + item.quantity + '" min="0" aria-label="Quantity">' +
              '<button type="button" class="cart-drawer__qty-btn" data-cart-drawer-qty-increase aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="cart-drawer__remove" data-cart-drawer-remove aria-label="Remove item">' +
              '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                '<polyline points="3 6 5 6 21 6"></polyline>' +
                '<path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"></path>' +
                '<path d="M10 11v6"></path>' +
                '<path d="M14 11v6"></path>' +
                '<path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>' +
              '</svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</li>';
    });
    html += '</ul>';
    body.innerHTML = html;
    syncRxShipBox();
    if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      try { window.jdgm.customizeBadges(); } catch (err) {}
    }
    // Upgrade the JS-rendered items with the server-rendered drawer body so
    // Judge.me badges (review counts), variant titles, line discounts and
    // anything else only known to Liquid become accurate. Prefer the section the
    // cart API already returned; only fall back to fetching the /cart page when
    // it is absent (a caller that did not ask for sections, or an older API).
    if (!upgradeBodyFromSections(cart)) fetchCartPageAndUpgradeBody();
  }

  // Mirrors the Liquid in sections/cart-drawer.liquid. This template rebuilds
  // every line after a quantity change, so without the same discount markup here
  // the struck-through original would render on load and vanish on the first +/-.
  // line_level_discount_allocations is what the cart AJAX API returns for a
  // discounted line, matching the Liquid's test rather than compare-at price.
  function linePriceHtml(item) {
    var discounted = item.line_level_discount_allocations
      && item.line_level_discount_allocations.length > 0;
    return (discounted
        ? '<s class="original-price money">' + formatMoney(item.original_line_price) + '</s>'
        : '')
      + '<span class="money' + (discounted ? ' cart-item--discount-price' : '') + '">'
      + formatMoney(item.final_line_price) + '</span>';
  }

  // Updates the numbers a quantity change actually moves, without rebuilding the
  // item list. Returns false if the structure shifted underneath us, so the
  // caller can fall back to a full re-render.
  //
  // This is what lets the request drop ?sections=cart-drawer. Having Shopify
  // render the drawer section costs ~500ms of a ~1190ms change request, and for a
  // quantity change every bit of that markup comes back identical except the
  // numbers - which the JSON already carries. Prices still go through
  // linePriceHtml, so a volume discount appearing or disappearing at the new
  // quantity is reflected too.
  // Last cart the server confirmed. Used to price an optimistic update, so it has
  // to be server truth rather than anything already adjusted on screen.
  var lastCart = null;

  function patchLines(cart) {
    if (!cart || !cart.items) return false;
    lastCart = cart;
    var rows = $$('[data-cart-drawer-item]');
    if (rows.length !== cart.items.length) return false;

    var byKey = {};
    cart.items.forEach(function (it, i) { byKey[it.key] = { item: it, line: i + 1 }; });

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var found = byKey[row.getAttribute('data-key')];
      if (!found) return false;
      row.setAttribute('data-line', String(found.line));

      var input = $('[data-cart-drawer-qty-input]', row);
      // Never stamp over a field the customer is still typing in.
      if (input && document.activeElement !== input) input.value = found.item.quantity;

      var price = $('[data-cart-drawer-item-price]', row);
      if (price) price.innerHTML = linePriceHtml(found.item);
    }

    clearQtySpinners();

    if (countEl) countEl.textContent = '(' + (cart.item_count || 0) + ')';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    updateHeaderCount(cart.item_count);
    return true;
  }

  // Set only for the duration of one dispatch, so the drawer's own cart:updated
  // listener can tell "I already patched this" from "something else changed the
  // cart". The event is still dispatched either way - cart-peek, july-cart-badge
  // and added-to-cart all listen for it.
  var patchedCart = null;

  function updateHeaderCount(count) {
    $$('[data-header-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      if (count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  function imageUrl(src, size) {
    if (!src) return '';
    // src may be a protocol-relative or absolute Shopify CDN URL
    var withProtocol = src.indexOf('//') === 0 ? 'https:' + src : src;
    return withProtocol.replace(/(\.(?:jpg|jpeg|png|gif|webp))(\?.*)?$/i, '_' + size + 'x$1$2');
  }

  function formatMoney(cents) {
    if (cents == null) return '';
    if (typeof window.Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    // Fallback path, and it has to honour the shop's format rather than assume
    // "$1.00". Shopify.formatMoney is not on every template - it is absent on
    // the Added to cart page - and this line hardcoding the symbol is what made
    // JS-drawn prices lose the space in this shop's "$ {{amount}}", and drop the
    // thousands separator the money filter applies.
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (/\{\{\s*amount\s*\}\}/.test(moneyFormat)) {
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
    }
    return '$' + amount;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }

  // Lightweight, dependency-free confetti burst rendered onto a transient
  // canvas layered over the cart drawer panel. Used to celebrate when the
  // free-shipping threshold is reached. Respects reduced-motion preferences.
  function fireConfetti() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var canvas = document.createElement('canvas');
    canvas.className = 'cart-drawer__confetti';
    // Full-viewport overlay so the burst covers the whole page, above
    // everything (drawer panel z-index is below this).
    canvas.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;' +
      'pointer-events:none;z-index:2147483647;';
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var dpr = window.devicePixelRatio || 1;
    var W = window.innerWidth;
    var H = window.innerHeight;
    canvas.width = W * dpr;
    canvas.height = H * dpr;
    ctx.scale(dpr, dpr);

    var colors = ['#22c55e', '#f59e0b', '#ec4899', '#3b82f6', '#a855f7', '#10b981', '#eab308'];
    var count = 1500;
    var cx = W / 2;
    var cy = H / 2;
    var particles = [];
    for (var i = 0; i < count; i++) {
      // Burst out from the center of the page in every direction, then
      // gravity pulls everything down. Each particle gets a random angle
      // (full 360°) and speed so the spread fans evenly across the page.
      var angle = Math.random() * Math.PI * 2;
      var speed = Math.random() * 16 + 8;
      particles.push({
        x: cx,
        y: cy,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        size: Math.random() * 7 + 4,
        color: colors[i % colors.length]
      });
    }

    // Stronger gravity so every particle falls down and off the bottom of
    // the screen rather than hovering / piling up in the middle.
    var gravity = 0.55;
    var start = null;
    // Long enough for even the slowest (upward-launched) particles to arc
    // back down and exit the bottom before the canvas is removed, so the
    // burst never freezes mid-page.
    var DURATION = 3900;

    // Fade out over the last third so the few remaining particles ease away
    // instead of snapping off at the end.
    var FADE_START = DURATION * 0.66;

    function frame(ts) {
      if (start === null) start = ts;
      var elapsed = ts - start;
      ctx.clearRect(0, 0, W, H);

      // One global alpha for the whole frame (all particles fade together),
      // so we can set it once instead of per particle.
      var alpha = elapsed < FADE_START ? 1 : Math.max(0, 1 - (elapsed - FADE_START) / (DURATION - FADE_START));
      ctx.globalAlpha = alpha;

      for (var j = 0; j < particles.length; j++) {
        var p = particles[j];
        p.vy += gravity;
        p.x += p.vx;
        p.y += p.vy;
        p.vx *= 0.99;

        // Skip particles that have left the viewport — no point spending
        // draw cycles on them. This is what keeps 2000 particles smooth.
        if (p.x < -p.size || p.x > W + p.size || p.y > H + p.size) continue;

        // setTransform avoids the save()/restore() pair per particle.
        ctx.setTransform(dpr, 0, 0, dpr, p.x * dpr, p.y * dpr);
        ctx.fillStyle = p.color;
        ctx.beginPath();
        ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      if (elapsed < DURATION) {
        requestAnimationFrame(frame);
      } else if (canvas.parentNode) {
        canvas.parentNode.removeChild(canvas);
      }
    }
    requestAnimationFrame(frame);
  }

  // Public API
  window.openCartDrawer = open;
  window.closeCartDrawer = close;
  window.refreshCartDrawer = fetchAndRender;
  // The cart page runs its own shipping bar and wants the same celebration.
  // Exposed rather than copied so there is one burst to tune, not two.
  window.fireCartConfetti = fireConfetti;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
